import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import { updateAccessToken } from "../../utils/storage";
import {
  Link,
  useLocation,
  useNavigate,
  useNavigation,
} from "react-router-dom";

import { useTheme } from "@mui/material/styles";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { signUpSchema } from "../../validate/authentication";
import { EmailInput, PasswordInput } from "../ui-elements/inputs";
import InputPassword from "../ui-elements/input-password";
import {
  btnApple,
  btnGoogle,
  btnStyOne,
  line,
  lineText,
} from "../ui-elements/styles-button";
import { PATH_AUTH, PATH_ONBOARD } from "../../routes/path";
import { useMutation } from "@tanstack/react-query";
import { useNotificationService } from "../../hooks/notification";
import {
  apiActivateAccount,
  apiResendActivateEmail,
  apiSignUp,
} from "../../api/authentication";
import { LoadingButton } from "@mui/lab";
import { OTP } from "../otp-container";
import { labelSty } from "../ui-elements/styles-input";

export const OtpDetails = ({ email }: { email: string }) => {
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const [count_down, setCount_down] = useState(120); // 120 seconds = 2 minutes
  const [can_resend, setCan_resend] = useState(false);

  useEffect(() => {
    if (count_down > 0) {
      const timer = setTimeout(() => setCount_down(count_down - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCan_resend(true);
    }
  }, [count_down]);
  const [otp, setOtp] = React.useState("");
  const mutation = useMutation({
    mutationFn: apiActivateAccount,
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("details" in data) {
          showNotification(data?.details ?? "", "error");
          return;
        }
      }
      //  Handle success
      if ("data" in data) {
        showNotification(
          data?.data?.message ?? "Activated successful",
          "success"
        );
        const { access_token, expires_in, token_type } = data.data;
        updateAccessToken(access_token, expires_in, token_type);
        navigate(PATH_ONBOARD.root);
      }
    },
    onError: (error) => {
      console.error("Process failed", error);
      // Handle error
      showNotification("Process failed", "error");
    },
  });

  const resend_link = async () => {
    if (can_resend) {
      const resend = await apiResendActivateEmail(email);

      setCan_resend(false);
      setCount_down(120);
    }

    const resend = await apiResendActivateEmail(email);
  };

  const on_submit = async () => {
    const data = { otp: otp, email: email };
    mutation.mutate(data);
  };
  const format_time = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: "8rem" }}>
      <OTP
        separator={<span>-</span>}
        value={otp}
        onChange={setOtp}
        length={4}
      />
      <Stack sx={{ my: 4 }}>
        <LoadingButton
          loading={mutation.isPending}
          type="submit"
          onClick={on_submit}
          variant="contained"
          sx={{ ...btnStyOne, width: "80%", mx: "auto" }}
        >
          Activate Account
        </LoadingButton>
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{ mx: 4 }}
        >
          <Button onClick={() => navigate(-1)}>Back</Button>
          {can_resend ? (
            <LoadingButton onClick={resend_link}>Resend</LoadingButton>
          ) : (
            <Typography
              variant="body2"
              sx={{ ...labelSty, textAlign: "center", my: 3 }}
            >
              {`Resend OTP (${format_time(count_down)})`}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
